<template>
  <div class="app-bar-action diag-app-bar">
    <v-badge
      dot
      overlap
      offset-x="8"
      offset-y="8"
      :color="statusBadgeColor"
      :value="true"
    >
      <v-btn
        icon
        small
        class="app-bar-btn"
        :title="statusTitle"
        @click="dialogOpen = true"
      >
        <v-icon :color="statusIconColor">mdi-monitor-dashboard</v-icon>
      </v-btn>
    </v-badge>

    <v-dialog
      v-model="dialogOpen"
      max-width="960"
      scrollable
      content-class="diag-app-bar-dialog"
    >
      <DiagnosticoSistema
        v-if="dialogOpen"
        embedded
        @status-update="onStatusUpdate"
      />
    </v-dialog>

    <div v-if="!dialogOpen" class="diag-app-bar-monitor" aria-hidden="true">
      <DiagnosticoSistema @status-update="onStatusUpdate" />
    </div>
  </div>
</template>

<script>
import DiagnosticoSistema from '@/components/diagnostico/DiagnosticoSistema.vue'

export default {
  name: 'DiagnosticoSistemaAppBar',

  components: {
    DiagnosticoSistema,
  },

  data () {
    return {
      dialogOpen: false,
      status: {
        overallStatus: 'yellow',
        overallStatusTitle: 'Diagnóstico del sistema',
        overallStatusText: '',
        internetStatusLabel: '',
        latencyStatusLabel: '',
        hardwareStatusLabel: '',
      },
    }
  },

  computed: {
    statusBadgeColor () {
      const map = {
        green: 'success',
        yellow: 'warning',
        red: 'error',
      }
      return map[this.status.overallStatus] || 'warning'
    },

    statusIconColor () {
      const map = {
        green: 'success darken-1',
        yellow: 'warning darken-1',
        red: 'error darken-1',
      }
      return map[this.status.overallStatus] || 'grey darken-1'
    },

    statusTitle () {
      if (this.status.overallStatusTitle && this.status.overallStatusTitle !== 'Diagnóstico del sistema') {
        return this.status.overallStatusTitle + ' — clic para ver diagnóstico'
      }
      return 'Estado del sistema — clic para ver diagnóstico'
    },
  },

  methods: {
    onStatusUpdate (payload) {
      this.status = Object.assign({}, this.status, payload)
    },
  },
}
</script>

<style scoped>
.diag-app-bar-monitor {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  pointer-events: none;
}
</style>

<style>
.diag-app-bar-dialog {
  margin: 12px;
}
</style>
